const LEATHER = "#f5e6d3";
const WOOD = "#8b3a2a";
const WOOD_DARK = "#5c2e1a";
const LEATHER_ROUGH = 0.6;
const WOOD_ROUGH = 0.3;
const WOOD_METAL = 0.1;

function Rect({ args, position, color, roughness, metalness, rotation }: { args: [number, number, number]; position?: [number, number, number]; color?: string; roughness?: number; metalness?: number; rotation?: [number, number, number] }) {
	return (
		<mesh position={position} rotation={rotation} castShadow receiveShadow>
			<boxGeometry args={args} />
			<meshStandardMaterial color={color ?? LEATHER} roughness={roughness ?? LEATHER_ROUGH} metalness={metalness ?? 0} />
		</mesh>
	);
}

function Cyl({ args, position, color, roughness, rotation }: { args: [number, number, number, number]; position?: [number, number, number]; color?: string; roughness?: number; rotation?: [number, number, number] }) {
	return (
		<mesh position={position} rotation={rotation} castShadow receiveShadow>
			<cylinderGeometry args={args} />
			<meshStandardMaterial color={color ?? LEATHER} roughness={roughness ?? LEATHER_ROUGH} />
		</mesh>
	);
}

function ThreeSeatSofa() {
	// Lift the whole sofa up by leg half-height (0.06) so the bottom of the legs
	// sit exactly on y=0 instead of straddling the floor → eliminates z-fighting.
	return (
		<group position={[0, 0.06, 0]}>
			<Rect args={[3.6, 0.09, 1.125]} position={[0, 0.045, 0]} color={WOOD} roughness={WOOD_ROUGH} metalness={WOOD_METAL} />
			<Rect args={[0.06, 0.06, 0.06]} position={[-1.65, -0.03, 0.48]} color={WOOD_DARK} />
			<Rect args={[0.06, 0.06, 0.06]} position={[1.65, -0.03, 0.48]} color={WOOD_DARK} />
			<Rect args={[0.06, 0.06, 0.06]} position={[-1.65, -0.03, -0.48]} color={WOOD_DARK} />
			<Rect args={[0.06, 0.06, 0.06]} position={[1.65, -0.03, -0.48]} color={WOOD_DARK} />
			<Rect args={[3.0, 0.24, 1.05]} position={[0, 0.21, 0]} />
			<Rect args={[3.6, 0.75, 0.18]} position={[0, 0.54, -0.495]} />
			<Cyl args={[0.09, 0.09, 3.3, 12]} position={[0, 0.93, -0.495]} rotation={[0, 0, Math.PI / 2]} />
			<Rect args={[0.27, 0.675, 1.125]} position={[-1.635, 0.3375, 0]} />
			<Rect args={[0.27, 0.675, 1.125]} position={[1.635, 0.3375, 0]} />
			<Rect args={[0.33, 0.06, 1.125]} position={[-1.635, 0.705, 0]} color={WOOD} roughness={WOOD_ROUGH} metalness={WOOD_METAL} />
			<Rect args={[0.33, 0.06, 1.125]} position={[1.635, 0.705, 0]} color={WOOD} roughness={WOOD_ROUGH} metalness={WOOD_METAL} />
		</group>
	);
}

function SingleChair() {
	// Same lift as ThreeSeatSofa — legs rest on y=0, no floor intersection.
	return (
		<group position={[0, 0.06, 0]}>
			<Rect args={[1.2, 0.09, 1.05]} position={[0, 0.045, 0]} color={WOOD} roughness={WOOD_ROUGH} metalness={WOOD_METAL} />
			<Rect args={[0.06, 0.06, 0.06]} position={[-0.525, -0.03, 0.45]} color={WOOD_DARK} />
			<Rect args={[0.06, 0.06, 0.06]} position={[0.525, -0.03, 0.45]} color={WOOD_DARK} />
			<Rect args={[0.06, 0.06, 0.06]} position={[-0.525, -0.03, -0.45]} color={WOOD_DARK} />
			<Rect args={[0.06, 0.06, 0.06]} position={[0.525, -0.03, -0.45]} color={WOOD_DARK} />
			<Rect args={[0.9, 0.21, 0.975]} position={[0, 0.195, 0]} />
			<Rect args={[1.2, 0.675, 0.15]} position={[0, 0.495, -0.45]} />
			<Cyl args={[0.075, 0.075, 0.9, 10]} position={[0, 0.84, -0.45]} rotation={[0, 0, Math.PI / 2]} />
			<Rect args={[0.21, 0.6, 1.05]} position={[-0.495, 0.3, 0]} />
			<Rect args={[0.21, 0.6, 1.05]} position={[0.495, 0.3, 0]} />
			<Rect args={[0.27, 0.06, 1.05]} position={[-0.495, 0.63, 0]} color={WOOD} roughness={WOOD_ROUGH} metalness={WOOD_METAL} />
			<Rect args={[0.27, 0.06, 1.05]} position={[0.495, 0.63, 0]} color={WOOD} roughness={WOOD_ROUGH} metalness={WOOD_METAL} />
		</group>
	);
}

function CoffeeTable() {
	return (
		<group>
			<Rect args={[1.5, 0.075, 0.9]} position={[0, 0.675, 0]} color={WOOD} roughness={WOOD_ROUGH} metalness={WOOD_METAL} />
			<Rect args={[1.2, 0.06, 0.6]} position={[0, 0.225, 0]} color={WOOD} roughness={WOOD_ROUGH} metalness={WOOD_METAL} />
			<Rect args={[0.06, 0.63, 0.06]} position={[-0.66, 0.375, -0.39]} color={WOOD_DARK} />
			<Rect args={[0.06, 0.63, 0.06]} position={[0.66, 0.375, -0.39]} color={WOOD_DARK} />
			<Rect args={[0.06, 0.63, 0.06]} position={[-0.66, 0.375, 0.39]} color={WOOD_DARK} />
			<Rect args={[0.06, 0.63, 0.06]} position={[0.66, 0.375, 0.39]} color={WOOD_DARK} />
		</group>
	);
}

export default function Sofa({ position }: { position?: [number, number, number] }) {
	return (
		<group position={position} rotation={[0, -Math.PI / 2, 0]}>
			<group position={[0, 0, -0.7]} scale={[1, 1.4, 1]}>
				<ThreeSeatSofa />
			</group>
			<group position={[-2.0, 0, 0.5]} rotation={[0, Math.PI / 2, 0]} scale={[1, 1.4, 1]}>
				<SingleChair />
			</group>
			<group position={[2.0, 0, 0.5]} rotation={[0, -Math.PI / 2, 0]} scale={[1, 1.4, 1]}>
				<SingleChair />
			</group>
			<group position={[0, 0, 0]}>
				<CoffeeTable />
			</group>
		</group>
	);
}